<template>
  <div class="videos">
    <div
      v-for="(item, i) in videos"
      :key="`${$route.name}-${item.anime_id}-${i}`"
      :data-video-id="item.anime_id"
      class="item"
    >
      <div @click="getCurrentItem(item.anime_id || item.sh_id || item.kinopoisk_id)" class="poster" title="Подробнее">
        <nuxt-img
          v-if="isDesktop ? i < 4 : i < 2"
          :src="`/static_files/uploads/posters/${item.anime_id || item.id}.webp`"
          :alt="`${item.title} / ${item.title_orig}`"
          preload
          sizes="245px xs:50vw"
          format="webp"
          quality="70"
        />
        <nuxt-img
          v-else
          :src="`/static_files/uploads/posters/${item.anime_id || item.id}.webp`"
          :alt="`${item.title} / ${item.title_orig}`"
          fit="cover"
          loading="lazy"
          sizes="245px xs:50vw"
          format="webp"
          quality="70"
        />
        <!-- <img
          :data-src="filmPoster(item)"
          :alt="`${item.title} / ${item.title_orig}`"
          src="/static_files/no-poster.png"
          class="lazyload"
        > -->
      </div>
      <nuxt-link
        :to="`/film/${item.pretty ? item.pretty : item.anime_id || item.sh_id || item.kinopoisk_id}`"
        :title="`смотреть онлайн ${item.title}${!item.title && item.title_orig ? ` / ${item.title_orig}` : ''}`"
        class="title"
      >
        {{ item.title }}
      </nuxt-link>
    </div>

    <transition name="fadeInFast">
      <div v-if="currentItem" class="modal" @click="closeModal">
        <template v-if="!isDesktop">
          <transition name="toTop">
            <div v-if="showModal" class="close-line"></div>
          </transition>
        </template>
        
        <transition :name="isDesktop ? 'fadeInScale' : 'toTop'">
          <div v-if="showModal" class="wrapper" onclick="event.stopPropagation()">
            <div class="actions" :class="{ 'active': showAbout }">
              <div v-if="showAbout" @click="showAbout = false" class="arrow-left"></div>
              <div @click="closeModal" class="close"></div>
            </div>

            <div class="header">
              <div class="poster">
                <nuxt-img
                  :src="`/static_files/uploads/posters/${currentItem.anime_id}.webp`"
                  :alt="`${currentItem.title} / ${currentItem.title_orig}`"
                  fit="cover"
                  loading="lazy"
                  :width="isDesktop ? 200 : 150"
                  :height="isDesktop ? 290 : 225"
                  format="webp"
                  quality="70"
                />
                <!-- <img :src="filmPoster(currentItem)" /> -->
              </div>
              <div class="title">
                <nuxt-link :to="`/film/${currentItem.pretty}`" tag="strong">
                  {{ currentItem.title }}
                </nuxt-link>
                <span @click="showAbout = true"><svg fill="currentColor" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" width="16px" height="16px"><path d="m12.000375 3c4.97025 0 9 4.02975 9 9s-4.02975 9-9 9-9-4.02975-9-9 4.02975-9 9-9zm0 1.3125c-4.239 0-7.6875 3.4485-7.6875 7.6875s3.4485 7.6875 7.6875 7.6875 7.6875-3.4485 7.6875-7.6875-3.4485-7.6875-7.6875-7.6875zm1.147125 5.89875v6.804h-2.295v-6.804zm-1.147125-3.226875c.35925 0 .66375.12.91125.3585.2475.23775.37125.52875.37125.87075s-.12375.63225-.37125.87c-.2475.2385-.552.35775-.91125.35775-.36 0-.6645-.11925-.912-.35775-.2475-.23775-.3705-.528-.3705-.87s.123-.633.3705-.87075c.2475-.2385.552-.3585.912-.3585z" fill-rule="evenodd" transform="translate(-3 -3)"></path></svg> О продукте</span>
              </div>
            </div>
            <div class="body">
              <div class="player">
                <iframe
                  v-if="showPlayer && currentItem.link"
                  ref="iframe"
                  :src="currentItem.link + '?uid=1JGDOR'"
                  frameBorder="0"
                  allow="autoplay *; fullscreen *"
                  allowfullscreen
                  id="iframe"
                  class="iframe"
                />
              </div>

              <div v-if="currentItem.material_data.description">
                <div class="row">
                  Описание
                </div>
                <div class="text">
                  {{ currentItem.material_data.description }}
                </div>
              </div>
            </div>

            <transition name="modalToLeft">
              <div v-if="showAbout" class="about">
                <ul>
                  <li v-if="currentItem.material_data.anime_kind">
                    Тип:
                    <div>
                      <nuxt-link
                        :to="`/?type=${currentItem.material_data.anime_kind}`"
                        style="text-transform:capitalize;"
                      >
                        {{ currentItem.material_data.anime_kind | filterKind }}
                      </nuxt-link>
                    </div>
                  </li>
                  <li v-if="currentItem.material_data.genres">
                    Жанр:
                    <div>
                      <nuxt-link
                        v-for="g in currentItem.material_data.genres"
                        :key="`genres-${g}`"
                        :to="`/?genre=${g}`"
                        style="text-transform:capitalize;"
                      >
                        {{ g }}
                      </nuxt-link>
                    </div>
                  </li>
                  <li v-if="currentItem.material_data.anime_status">
                    Статус:
                    <div>
                      <nuxt-link :to="`/?status=${currentItem.material_data.anime_status.toLowerCase()}`"
                        :class="{
                          green: currentItem.material_data.anime_status.toLowerCase() === 'ongoing',
                          red: currentItem.material_data.anime_status.toLowerCase() === 'released',
                          orange: currentItem.material_data.anime_status.toLowerCase() === 'anons',
                        }"
                        class="status"
                      >{{
                        currentItem.material_data.anime_status.toLowerCase() === 'ongoing'
                          ? 'Онгоинг'
                          : currentItem.material_data.anime_status.toLowerCase() === 'released'
                            ? 'Завершен'
                            : currentItem.material_data.anime_status.toLowerCase() === 'anons'
                              ? 'Анонс'
                              : '' }}</nuxt-link>
                      c {{ currentItem.material_data.aired_at | filterShortDate }}
                    </div>
                  </li>
                  <li v-if="currentItem.material_data.episodes_aired">
                    Эпизодов вышло в эфир:
                    <div>
                      <template v-if="currentItem.material_data.episodes_aired && currentItem.material_data.episodes_aired > 0">
                        {{ currentItem.material_data.episodes_aired }}
                      </template>
                      <template v-if="(currentItem.material_data.episodes_aired && currentItem.material_data.episodes_aired > 0) && currentItem.material_data.episodes_total">
                        из
                      </template>
                      <template v-if="currentItem.material_data.episodes_total">
                        {{ currentItem.material_data.episodes_total }}
                      </template>
                    </div>
                  </li>
                  <li v-if="currentItem.material_data.duration">
                    <template v-if="currentItem.type === 'anime'">
                      Продолжительность:
                    </template>
                    <template v-else>
                      Длительность эпизода:
                    </template>
                    <div>
                      <template v-if="Math.floor((currentItem.material_data.duration) / 60)">
                        {{ Math.floor((currentItem.material_data.duration) / 60) }}ч.
                      </template>
                      <template v-if="Math.floor((currentItem.material_data.duration) % 60)">
                        {{ Math.floor((currentItem.material_data.duration) % 60) }} мин.
                      </template>
                    </div>
                  </li>
                  <li v-if="currentItem.material_data.kinopoisk_rating">
                    Рейтинг КиноПоиск:
                    <div>{{ ('' + currentItem.material_data.kinopoisk_rating).slice(0, 3) }}</div>
                  </li>
                  <li v-if="currentItem.material_data.imdb_rating">
                    Рейтинг IMDb:
                    <div>{{ ('' + currentItem.material_data.imdb_rating).slice(0, 1) + (('' + currentItem.material_data.imdb_rating).slice(1) || '.0') }}</div>
                  </li>
                  <li v-if="currentItem.material_data.shikimori_rating">
                    Рейтинг Shikimori:
                    <div>{{ ('' + currentItem.material_data.shikimori_rating).slice(0, 1) + (('' + currentItem.material_data.shikimori_rating).slice(1) || '.0') }}</div>
                  </li>
                  <li v-if="currentItem.material_data.premiere_ru">
                    Премьера (РФ):
                    <div>{{ currentItem.material_data.premiere_ru | filterShortDate }}</div>
                  </li>
                  <li v-if="currentItem.material_data.premiere_world">
                    Премьера (мир):
                    <div>{{ currentItem.material_data.premiere_world | filterShortDate }}</div>
                  </li>
                  <li v-if="currentItem.material_data.rating_mpaa">
                    PG:
                    <div>{{ currentItem.material_data.rating_mpaa }}</div>
                    <sup v-if="parseInt(currentItem.material_data.rating_mpaa)" :title="`Лицам до ${
                      parseInt(currentItem.material_data.rating_mpaa)
                    } лет обязательно присутствие взрослого`">?</sup>
                  </li>
                  <li v-if="currentItem.material_data.writers && currentItem.material_data.writers.length">
                    Авторы:
                    <div>{{ currentItem.material_data.writers.join(', ') }}</div>
                  </li>
                  <li v-if="currentItem.material_data.studios && currentItem.material_data.studios.length">
                    Студия:
                    <div>{{ currentItem.material_data.studios.join(', ') }}</div>
                  </li>
                  <li v-if="currentItem.material_data.other_titles_jp && currentItem.material_data.other_titles_jp.length">
                    Название по-японски:
                    <div>{{ currentItem.material_data.other_titles_jp.join(', ') }}</div>
                  </li>
                  <!-- <li v-if="currentItem.material_data.anime_licensed_by && currentItem.material_data.anime_licensed_by.length">
                    Лицензировано:
                    <div>{{ currentItem.material_data.anime_licensed_by.join(', ') }}</div>
                  </li> -->
                  <li v-if="currentItem.material_data.anime_license_name">
                    Лицензионное название:
                    <div
                      v-if="currentItem.material_data.anime_license_name"
                      itemprop="alternativeHeadline"
                    >
                      - {{ currentItem.material_data.anime_license_name }}
                    </div>
                  </li>
                  <li v-if="currentItem.material_data.other_titles && currentItem.material_data.other_titles.length">
                    Другие названия:
                    <div>
                      <div v-if="currentItem.material_data.anime_title" itemprop="alternativeHeadline">
                        <div>- {{ currentItem.material_data.anime_title }}</div>
                      </div>
                      <div
                        v-for="ot in currentItem.material_data.other_titles"
                        :key="ot"
                        itemprop="alternativeHeadline"
                      >
                        <div>- {{ ot }}</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: { videos: { type: Array, require: true, default: () => ([]) } },
  filters: {
    filterKind(val) {
      if (val === 'movie') {
        return 'Фильм'
      } else if (val === 'special') {
        return 'Спэшл'
      }
      return val
    },
    filterShortDate(val) {
      const value = val
      const months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря'
      ]
      const day = new Date(value).getDate()
      const month = new Date(value).getMonth()
      const year = new Date(value).getFullYear()
      return `${day} ${months[month]} ${year}`
    },
    filterDate(val) {
      const value = val
      const months = [
        'янв',
        'фев',
        'мар',
        'апр',
        'мая',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек'
      ]
      const day =
        new Date(value).getDate() >= 10
          ? new Date(value).getDate()
          : '0' + new Date(value).getDate()
      const month = new Date(value).getMonth()
      const year = new Date(value).getFullYear()
      const hour =
        new Date(value).getHours() >= 10
          ? new Date(value).getHours()
          : '0' + new Date(value).getHours()
      const min =
        new Date(value).getMinutes() >= 10
          ? new Date(value).getMinutes()
          : '0' + new Date(value).getMinutes()
      return `${day} ${months[month]} ${year} в ${hour}:${min}`
    }
  },
  watch: {
    currentItem(val) {
      if (val) {
        document.body.style.overflow = 'hidden'
        setTimeout(() => (this.showModal = true))
        setTimeout(() => (this.showPlayer = true), 400)
      } else {
        document.body.style.overflow = ''
        this.showAbout = false
        this.showModal = false
        this.showPlayer = false
      }
    },
  },
  computed: mapState(['isDesktop']),
  data() {
    return {
      showModal: false,
      loading: false,
      showAbout: false,
      currentItem: null,
      showPlayer: false,
    }
  },
  mounted() {
    window.addEventListener('keydown', this.closeEsc)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.closeEsc)
  },
  methods: {
    closeEsc(e) {
      if (e.keyCode === 27) {
        this.closeModal()
      }
    },
    closeModal() {
      this.showModal = false
      setTimeout(() => (this.currentItem = null), 200)

      setTimeout(() => (console.log("hidden")), 300);
    },
    moveModal() {
      const vm = this
      const modal = document.querySelector('.videos .modal .wrapper')
      const closeLine = document.querySelector('.videos .modal .close-line')
      let startY = 0
      let currentY = 0
      let isDragging = false

      modal.addEventListener('touchstart', (e) => {
        startY = e.touches[0].clientY
        isDragging = false
      })

      modal.addEventListener('touchmove', (e) => {
        currentY = e.touches[0].clientY
        const diff = currentY - startY

        if (diff > 0) {
          isDragging = true
          modal.style.transform = `translateY(${diff}px)`
          closeLine.style.opacity = 0
        }
      })

      modal.addEventListener('touchend', () => {
        if (isDragging && currentY - startY > 300) {
          vm.closeModal()
        } else {
          modal.style.transform = 'translateY(0)'
          closeLine.style.opacity = 1
        }
      })
    },
    async getCurrentItem(id) {
      if (this.loading) return
      this.loading = true

      const { data } = await this.$axios.get(`/api/info?id=${id}`)

      this.loading = false

      if (!data.error) {
        this.currentItem = data
        setTimeout(() => this.moveModal(), 1000)
      }
    },
  },
}
</script>

<style src="~/assets/videos.styl" lang="stylus" />
